export class ClassMaster {
    id: string;
    title: string;
    description: string;
    sequence: string;
    price: string;
    maxCapacity: string;
    handicapAccess: boolean;
    online: boolean;
    MHSRCProgramId: string;
    active: boolean;
    classTypeId: string;
}



// WEBPACK FOOTER //
// ./src/app/models/class-master.ts